import { FC } from "react";
import { observer } from "mobx-react";
import { DividendPowerOfAttorneyForm } from "./dividendPowerOfAttorneyDomain";
import { NumberField } from "@/dbot/common/commonComponents";
import { VBox } from "@/components-v2/Box";
import { CURRENCY_NOK } from "@/utils/currency";
import { RadioFieldQuestion } from "@/common/commonComponents";

export const DividendPowerOfAttorneyView: FC<{
  form: DividendPowerOfAttorneyForm;
}> = observer(({ form }) => {
  return (
    <VBox gap={"md"}>
      <RadioFieldQuestion
        question={{ key: "decisions.dividend.powerOfAttorneyFor.questionText" }}
        field={form.powerOfAttorneyFor}
        fieldName={"powerOfAttorneyFor"}
        isLocked={form.isProjectLocked}
      />
      <RadioFieldQuestion
        question={{ key: "decisions.dividend.powerOfAttorneyLimit.amount" }}
        field={form.boardDecidesMaxAmount}
        fieldName={"boardDecidesMaxAmount"}
        isLocked={form.isProjectLocked}
      />
      {!form.boardDecidesMaxAmount.value && (
        <NumberField
          field={form.powerOfAttorneyLimit}
          prefix={CURRENCY_NOK}
          isLocked={form.isProjectLocked}
        />
      )}
    </VBox>
  );
});
